import React from 'react';
import RichText from '../../Prismic/RichText';
import EditableLinks from './EditableLinks';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

const EditableContent = props => {
  const hasGiftwrapAddons = !isEmpty(props.giftwrapAddons);
  const hasExtraAddons = !isEmpty(props.extraAddons);

  return (
    <React.Fragment>
      <span className="line-item-ii-customisation">
        {!isEmpty(props.expandedCustomisation)
          ? <RichText fields={props.expandedCustomisation} />
          : props.type
        }
      </span>
      {hasGiftwrapAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-ii-option line-item-option--giftwrap">
          + {props.giftwrapAddons.map(addon => addon.label).join(' + ')}
        </span>
      )}
      {hasExtraAddons && !props.isCustomisationsExpanded && (
        <span className="line-item-ii-option line-item-option--giftwrap">
          + {props.extraAddons.map(addon => addon.label).join(' + ')}
        </span>
      )}
      {!props.isMobile && <EditableLinks {...props} />}
    </React.Fragment>
  );
};

EditableContent.propTypes = {
  expandedCustomisation: PropTypes.array,
  customisationString: PropTypes.string.isRequired,
  hasCustomisations: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  giftwrapAddons: PropTypes.array,
  extraAddons: PropTypes.array,
  isCustomisationsExpanded: PropTypes.bool,
  isMobile: PropTypes.bool.isRequired,
};

export default EditableContent;



// WEBPACK FOOTER //
// ./src/client/js/view/components/LineItemII/EditableContent/EditableContent.js